import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "./Navbar";
import { FaUserGraduate, FaRobot } from "react-icons/fa";

const ChatHistory = () => {
  const location = useLocation();
  const { setSessionTimeout, setAlert, setMessage } = useContext(languageContext);

  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const chat_history_student = async () => {
    const student_id = location.state?.student_id;
    if (!student_id) return;

    setIsLoading(true);
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/admin_student_chat_history",
        JSON.stringify({ id: student_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setMessages(response.data.chat_history);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Something went wrong. Please try again later.");
        console.error("Chat History Fetch Error:", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    chat_history_student();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <Navbar />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-24 pb-16">
        <h2 className="text-4xl font-bold text-center text-blue-800 mb-12">
          🧾 Admin Panel – Student Chat Records
        </h2>

        {isLoading ? (
          <div className="flex justify-center items-center py-20">
            <div className="w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : messages.length === 0 ? (
          <div className="text-center text-gray-500 py-32 text-lg">
            <p className="mb-4">No chat records available for this student.</p>
          </div>
        ) : (
          <div className="space-y-6">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className="bg-white border border-gray-200 rounded-2xl p-6 shadow hover:shadow-lg transition-all"
              >
                <div className="flex justify-between items-center text-sm text-gray-400 mb-3">
                  <span>{new Date(msg.timestamp).toLocaleString()}</span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-0.5 rounded-full font-medium">
                    Chat ID: {msg.id}
                  </span>
                </div>

                <div className="flex items-start gap-3 mb-4">
                  <FaUserGraduate className="text-blue-600 mt-1.5" size={18} />
                  <div>
                    <p className="text-base font-semibold text-blue-800 mb-1">
                      Student:
                    </p>
                    <p className="text-gray-700 text-sm">
                      {msg.user_question || (
                        <span className="italic text-gray-400">No question provided</span>
                      )}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <FaRobot className="text-emerald-600 mt-1.5" size={18} />
                  <div>
                    <p className="text-base font-semibold text-emerald-700 mb-1">
                      Assistant:
                    </p>
                    <p className="text-gray-700 text-sm">
                      {msg.bot_response || (
                        <span className="italic text-gray-400">No response recorded</span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatHistory;
